import React, { useContext, ComponentType } from "react";
import { Route, Redirect, RouteProps } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { useAccess } from "../context/AccessContext";
import { FeatureCode } from "../constants/constants";

interface PrivateRouteProps extends RouteProps {
    component: ComponentType<any>;
    access?: "authenticated" | "admin" | "systemAdmin";
    feature?: FeatureCode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
    component: Component,
    access = "authenticated",
    feature,
    ...rest
}) => {
    const authContext = useContext(AuthContext);

    if (!authContext) {
        throw new Error("PrivateRoute must be used within an AuthProvider");
    }

    const { canAccessAdmin, isAuthenticated, isSystemAdmin, loading } = authContext;
    const accessContext = useAccess();

    if (loading || accessContext.loading) {
        return <div>Loading...</div>; // replace with spinner if needed
    }

    return (
        <Route
            {...rest}
            render={(props) => {
              const authorised =
                access === "authenticated" ||
                (access === "admin" && canAccessAdmin) ||
                (access === "systemAdmin" && isSystemAdmin);

              const featureAuthorised = !feature || accessContext.hasFeature(feature);

              return isAuthenticated && authorised && featureAuthorised ? (
                    <Component {...props} />
                ) : isAuthenticated ? (
                    <Redirect to="/dashboard" />
                ) : (
                    <Redirect to="/login" />
                );
            }}
        />
    );
};

export default PrivateRoute;
